import { SaveServiceProvider } from '@core/saves/saves.interface';
import { EnvironmentConfig } from './environment.type';

export const environment: EnvironmentConfig = {
  production: true,
  authServerHost: 'https://api.woordkr8.dev.gametailors.com/auth/',
  casHost: 'https://api.woordkr8.dev.gametailors.com/cas',
  dataPackage: 'woordkr8-dev',
  defaultGame: 'woordkr8',
  aspectRatio: { width: 1920, height: 1080 },
  playGameUrl: 'https://play.woordkr8.dev.gametailors.com/',

  version_latestBuildNumber: '',
  version_latestCommitHash: '',
  version_latestDate: '',

  saveService: {
    provider: SaveServiceProvider.MEMORY,

    // TODO
    leerkr8: {
      url: 'http://localhost:8080/',
      api_key: 'M9ruB1zDdcIIJl4sLIg8e6CpTp+WU/SaeCC6DZZYhGRzudhUaNGBimoUHSpeKc6/gqTYjX+3cA7uywPpm5+l0g==',
    },
  },

  casReadonlyUser: {
    username: 'woordkr8-service',
    password: 'MKk1kYpp4xb0FLyEJ8uzprMw',
  },

  offlineDataFolder: 'data',
  useOfflineData: true,
};
